import { Link } from 'react-router-dom';
import './homePage.css';
import logo from '../assets/satsat-logo.svg';

const HomePage = () => {
  return (
    <main className="container">
      <img src={logo} alt="SatSat" className="homepage-logo" />

      <div className="blurb">
        <p>SatSat was born from the belief that hospitality is the currency of community, exchanged one meal at a time.</p>
        <p>It's a place to open your table or take a seat at someone else's. To show up as you are, share a meal, and leave with something we all need a little more of: connection.</p>
        <p>If you've been searching for that feeling, there's a seat waiting for you.</p>
      </div>

      <Link to="/signup" className="cta-btn">Sign Me Up</Link>
    </main>
  );
};

export default HomePage;
